// ==========================================================================
// Booking - By Denis
// ==========================================================================

import { loadData, handleErrors } from './helpers';
import serialize from 'form-serialize';

class BookNowButton {
  constructor() {
    this.bookingForm = document.querySelector('.js-booking-form');
    if (this.bookingForm) {
      this.updateUrl = this.bookingForm.getAttribute('data-url');
      this.roomTypeID = document.querySelector('#id_room_type_id');
      this.propertyID = document.querySelector('#id_property_id');
      this.rateCode = document.querySelector('#id_rate_code');
      this.queryRateCode = document.querySelector('#id_query_rate_code');
      this.usedPoints = document.querySelector('#id_used_points');
      this.crmPrice = document.querySelector('#id_crm_price');
      this.currentPrice = document.querySelector('#id_current_price');
      this.totalPrice = document.querySelector('#id_total_price');
      this.totalLoyaltyDiscount = document.querySelector('#id_total_loyalty_discount');
      this.crmDiscount = document.querySelector('#id_crm_discount');
      this.pricePerDay = document.querySelector('#id_price_per_day');
      this.priceType = document.querySelector('#id_price_type');
      this.bindEvents.bind(this);
      this.book.bind(this);
      this.change.bind(this);
      this.bindEvents();
    }
  }

  bindEvents() {
    // book button
    this.buttons = [...document.querySelectorAll('.js-book-option')];
    this.buttons.map(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        this.book(button);
      });
    });

    // loyalty options selector
    this.selectors = [...document.querySelectorAll('.js-loyalty-option-selector')];
    this.selectors.map(select => {
      select.addEventListener('change', event => {
        event.preventDefault();
        this.change(select);
      });
    });
  }

  book(button) {
    this.roomTypeID.value = button.getAttribute('data-room-type-id');
    this.propertyID.value = button.getAttribute('data-property-id');
    this.rateCode.value = button.getAttribute('data-rate-code');
    this.queryRateCode.value = button.getAttribute('data-query-rate-code');
    this.usedPoints.value = button.getAttribute('data-used-points');
    this.crmPrice.value = button.getAttribute('data-crm-price');
    this.currentPrice.value = button.getAttribute('data-current-price');
    this.totalPrice.value = button.getAttribute('data-total-price');
    this.totalLoyaltyDiscount.value = button.getAttribute('data-total-loyalty-discount');
    this.crmDiscount.value = button.getAttribute('data-crm-discount');
    this.pricePerDay.value = button.getAttribute('data-ppd');
    this.priceType.value = button.getAttribute('data-price-type');
    this.submit(button);
  }

  change(radio) {
    const discount = radio.getAttribute('data-total-loyalty-discount') || '0';
    const crmDiscount = radio.getAttribute('data-crm-discount') || '0';
    const price = radio.getAttribute('data-price') || '0';
    const crmPrice = radio.getAttribute('data-crm-price') || '0';
    const usedPoints = radio.getAttribute('data-used-points') || '0';
    const key = radio.name.replace('club-rate_', '');
    const bookButton = document.querySelector('#id_book_button_' + key);
    bookButton.setAttribute('data-used-points', usedPoints);
    bookButton.setAttribute('data-crm-price', crmPrice);
    bookButton.setAttribute('data-current-price', price);
    bookButton.setAttribute('data-total-loyalty-discount', discount);
    bookButton.setAttribute('data-crm-discount', crmDiscount);
  }

  submit(button) {
    button.setAttribute('disabled', true);
    button.classList.add('loading');
    loadData(
      this.bookingForm.getAttribute('data-ajax'),
      serialize(this.bookingForm, {
        hash: true,
      }),
    )
      .then(() => {
        window.location.href = this.bookingForm.getAttribute('action');
      })
      .catch((error) => {
        console.warn(error);
        button.removeAttribute('disabled');
        button.classList.remove('loading');
      });
  }
}

export default new BookNowButton();



// WEBPACK FOOTER //
// ./src/js/book.js